import ServicePageTemplate from "../components/ServicePageTemplate";
import SEO from "../components/SEO";

export default function GronYteskotsel() {
  return (
    <>
      <SEO
        title="Grönyteskötsel och häckklippning i Laholm | Trädfällarna"
        description="Häckklippning, slyröjning och enklare grönyteskötsel i Laholm med omnejd. För privatpersoner, BRF, fastighetsägare och företag — engångsuppdrag eller återkommande."
        path="/gronyteskotsel-och-hackklippning"
      />
      <ServicePageTemplate
        eyebrow="Tjänst"
        title="Grönyteskötsel och häckklippning"
        intro="Vi hjälper privatpersoner, fastighetsägare, bostadsrättsföreningar och företag med häckklippning, slyröjning och enklare grönyteskötsel — som engångsuppdrag eller löpande under säsongen."
        heroImage="/images/tradvard.webp"
        bodyHeading="Snyggare tomter, säkrare ytor"
        bodyText="En väl underhållen tomt eller fastighet är inte bara snyggare — den blir också tryggare och lättare att använda. Vi hjälper till med både engångsinsatser och återkommande grönyteskötsel anpassad efter er säsong och era ytor."
        bullets={[
          {
            title: "Häckklippning",
            text: "Formklippning, sänkning och underhåll av små som stora häckar.",
          },
          {
            title: "Sly- och röjning",
            text: "Vi tar bort sly, småträd och igenvuxen mark inför ny användning.",
          },
          {
            title: "Grönyteskötsel",
            text: "Enklare gräsklippning, ogräsrensning och uppsnyggning av gemensamma ytor.",
          },
          {
            title: "Återkommande uppdrag",
            text: "Vi tecknar gärna säsongsavtal för fastigheter, BRF och företag.",
          },
        ]}
        steps={[
          { title: "Vi tittar på ytan", text: "Vi går igenom omfattning och behov." },
          { title: "Tydlig offert", text: "Du får ett tydligt pris — engångs eller löpande." },
          { title: "Arbete utfört", text: "Vi utför arbetet och städar efter oss." },
        ]}
      />
    </>
  );
}
